import React, { Fragment } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Link,
  useParams,
  Outlet,
} from "react-router-dom";
import PropTypes from "prop-types";
import Footer from "./footer";
import Overview from "./overview";
import Navbar from "../components/navbar";
import "./projects.css";

const Projects = (props) => {
  var params = useParams();
  if (!("projectTitle" in params)) {
    //default to one of the titles when no entry has been clicked yet
    params = { projectTitle: "rain-check" };
  }
  console.log(params);
  return (
    <div className="main-container">
      <div className="archive-navbar-container">
        <Navbar navImgSrc="/feelers/feelerslogo.png"></Navbar>
      </div>
      <div className="projects-container">
        <div className="projects-table-container">
          <table className="projects-table">
            <thead>
              <tr>
                <th className="projects-header date">Date </th>
                <th className="projects-header title">Project Title </th>
                <th className="projects-header category">Category </th>
                <th className="projects-header status">Status </th>
              </tr>
            </thead>
            <tbody>
              {
                //the line below iterates through the 'projectdata' array and creates a table line from each entry in projectdata
                Object.entries(projectdata2).map(([id, entry]) => (
                  <tr key={id}>
                    {/*key is necessary for some reason otherwise React throws a fit*/}
                    <td className="projects-cell-contents">
                      {entry.date ?? "Date"}
                    </td>
                    <td>
                      <NavLink
                        to={`/archive/${id}`}
                        className="projects-cell-contents"
                      >
                        {entry.title}
                      </NavLink>
                    </td>
                    <td className="projects-cell-contents">
                      {entry.category ?? "Category"}
                    </td>
                    <td className="projects-cell-contents">
                      {entry.status ?? "Status"}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

        {/* ------------ OVERVIEW STARTS HERE --------------- 
			<Outlet> object links to overview.js and is passed the entry n projectdata2 for the current projectTitle
			 */}
        <div className="projects-overview">
          <Outlet context={projectdata2[params.projectTitle]} />
        </div>
      </div>
    </div>
  );
};

const projectdata2 = {
  "soai-2025": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Jun 2025",
    title: "School of Alternate Internets 2025",
    category: "Education",
    status: "Ongoing",
    image1: "/assets/soai_2025/soai_2025-1.webp",
		  overview: <p>
				  <b>APPLICATIONS NOW OPEN</b> <br /><br />
				  

Join Feelers this June and July for the 2025 edition of the School of Alternate Internets (SoAI), an alt-education programme for critical thinking, doing, and undoing around our shared online landscape. SoAI offers a rigorous and accessible study of our digital lives and struggles, both present and future, centering play and the delightful rupture of preconceptions.
<br /><br />
Driven by artistic research, discussion, and hands on activities, sessions will include:
– Becoming Black Box, a workshop by ants chua that draws on surveillance studies, drag, and decolonial theory, to examine our relationships to transparency in a hypersurveilled digital world.<br /><br />
– Machine Madlibs, an activity by Kapilan Naidu that offers an alternate perspective to fatalist attitudes toward generative AI, inviting participants to explore the creative possibilities (and absurdities) of Large Language Models (LLMs).<br /><br />
– Handshake Via Internet by Ashley Hi, a workshop that guides participants through hacking with both physical and digital internet infrastructures to create an interactive glossary of figurative tech terminology.<br /><br />
– Programming For Pleasure by Viknesh Kobinathan, an exercise in reclaiming and reconnecting with the visuals that delight us, through curating personal micro-screening programmes.
– And more!
<br /><br />
Info<br /><br />
Dates: Saturdays, 28 June  //  5 July  //  12 July  // 19 July<br />
Fees:   $48 (One-Day Pass*) //  $192 (Full Programme)<br />
*The One-Day Pass for 19 July includes the Symposium<br />
Student Pricing: Get 30% off the Full Programme Fee<br /><br />
Applications close on 6 June.

				  Learn more and apply now > <u><b><a href="https://tinyurl.com/soai2025">tinyurl.com/soai2025</a></b></u>

		  </p>, 
  },
  "waiting-to-upload": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Mar 2025",
    title: "Waiting To Upload",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "",
    overview: `DAMN! was Cake Theatre's 2025 iteration of Running With Strippers. Part of DAMN!, Waiting To Upload was a community library of books, essays, and zines that with a focus on how art and technology can interact in interdisciplinary and collaborative ways. The collection featured selected titles from the personal collections of DAMN!'s featured artists and original publications by Feelers.`, 
  },
  "season-2025-odds-and-ends": {
    date: "Feb 2025",
	title: "Season 2025: Odds and Ends",
    category: "Season",
    status: "Completed",
    image1: "/assets/szn2025_odds_and_ends/szn2025_odds_and_ends-2.webp",
    image2: "/assets/szn2025_odds_and_ends/szn2025_odds_and_ends-1.webp",
    image3: "",
		  overview: `Odds & Ends was Feelers' 2025 Season. This season examined trivial pursuits and ephemera, consequence and the inconsequential. Amidst a paradigm of constant innovation and clean solutions, Feelers looked at aftershocks, aftermaths, and the detritus left behind. This season consisted of: 

Open Ending: Post Growth SG hosted a Post Growth Circle which segued into a speculative writing workshop hosted by multidisciplinary artist ila. Through theoretical reading and collective storytelling, participants explored alternatives to the status quo of unfettered growth. 

Delete Party: In this cosy, after-hours gathering, tabs were closed, desktops were decluttered, and downloads folders were organised. Delete Party was a joyful confrontation with digital detritus where storage space was freed up and archival strategies were shared. 


Circuits and Transits: A collaboration between Feelers and Victoria Hertel, Circuits and Transits was a participatory techno-spiritual ritual where discarded electronics were disassembled and repurposed into talismans for wayfinding. 

How To Go On: In this panel discussion, a mainstay of Feelers’ Seasons, young arts professionals Jasmine See and Aida Nurellysa Ahmad discussed how they approach programming, producing, and sustaining their practices in the contemporary arts ecosystem. 

To Dwell A Little Longer: Teo Xiao Ting’s meditative essay on the afterlives of technical practices, featuring conversations with Sim Lim Tower shopkeepers and the artists whose practices they support.  
				  `,
  },
  "rain-check": {
    date: "Jan 2025",
    title: "Rain Check",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/rain_check/rain_check-3.webp",
    image2: "/assets/rain_check/rain_check-2.webp",
    image3: "/assets/rain_check/rain_check-1.webp",
    overview:
      "Rain Check was a performance installation at SCAPE as part of Comma Fest 2025. In the Rain Check universe, the Cloud has collapsed and internet access is sporadically available, depending on the weather. Sunlight determines whether one can go online, and the monsoon season precipitates a time of digital silence. Through kinetic sculpture and sensor choreography, Feelers explored the role of internet infrastructures in our everyday lives by imagining their intermittent absence. ",
  },
  "kl-art-book-fair": {
    date: "Dec 2024",
    title: "Kuala Lumpur Art Book Fair",
    category: "Exhibition / Performance",
    status: "Completed",
    overview: "Feelers visited the Kuala Lumpur Art Book Fair for the first time in 2024, bringing original publications and publications by Feelers Friends Yifan Wang, Hanae Gomez, and Ada Adhiyatma. ",
  },
  "bug-month": {
    date: "Nov 2024",
    title: "Bug Month",
    category: "Education",
    status: "Completed",
	image1: "/assets/bug_month/bug_month-1.webp",
	image2: "",
	image3: "",
    overview: `Bug Month was a trio of programmes focusing on technological bugs and dysfunction. 

Caterfeelers: Build A Bug 
In this cosy, intimate workshop, participants learned basic soldering and connecting of wires as they assembled their own electronic jewellery from our product line Caterfeelers. Participants could build either swish (a charm necklace and fidget spinner mini fan) or click-click (a low res camera necklace which came with 3 acrylic filters). Jewellery could also be customised with charms. Caterfeelers was a collaboration between Feelers and Mengju Lin.


Debug Ur Darlings: Repair-a-Thon Love is a ritual of repair, and repair, a ritual of love. This repair-a-thon was a gathering for a practice of self-sufficiency, care, and maintenance that resists a culture of disposability and embraces breakdowns as opportunities to learn. Participants brought devices that they wanted to fix rather than throw, and were guided to diagnose and fix their items.

Bring Your Own Bug Spray
Like a phantom in a machine, a moth caught in a relay, or a cockroach whispering from a telephone, a bug can be a dreadful haunting or a pleasant surprise. Through a series of speculative writing and coding exercises, participants contributed to a compendium of bug lore that documented shared anxieties around the fear of tech and tech failure through the courage of bug spray. Bring Your Own Bug Spray was a response to the exhibition Sorry For The Technical Difficulties, which ran from 8-17 November at Art Outreach."`,
  },
  "sgabf-2024": {
    date: "Nov 2024",
    title: "Singapore Art Book Fair 2024",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/sgabf_2024/sgabf_2024-1.webp",
	image2: "",
	image3: "",
    overview: "Feelers boothed at Singapore Art Book Fair 2024, bringing original publications and publications by Feelers Friends Yifan Wang, Hanae Gomez, and Ada Adhiyatma. The booth also featured a listening station for Voices In A Room and a Feelers-themed photobooth. ",
  },
  "feeler-turns-4": {
    date: "Oct 2024",
    title: "Feelers Turns 4",
    category: "Event",
    status: "Completed",
	image1: "/assets/feelers_turns_4/feelers_turns_4-1.webp",
	image2: "/assets/feelers_turns_4/feelers_turns_4-2.webp",
	image3: "", 
		  overview: <p>For Feelers' fourth birthday celebrations, friends gathered to party and play. The party featured fortune-telling, DJ sets by Bernice Gaspar and Kapilan Naidu, cocktails by Ashley Hi, food by ants chua, and live-coded visuals with Hydra by Gaetan Boisson. <br /><br />
				  TTRPGs with Feelers, which took place on the same weekend, was a tabletop roleplaying games session held as part of Feelers’ 4th Birthday Celebrations. Attendees played two TTRPGS. First, Apollo 47 Technical Handbook, which invites players to engage in workaday astronaut activities using a simple improvisatory rules set to play in a quiet world of technobabble and the slow progression of science. <br /><br />Second, Move Quietly and Tend Things, a bittersweet utopia story-game about recovery, repair and revelation, set in a derelict Southeast Asian megastructure sometime in the far future.</p>
  },
  "cloud-cryptid": {
    date: "Sep 2024",
    title: "Cloud Cryptid Friendship Society",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/ccfs_2024/ccfs_2024-1.webp",
	image2: "",
	image3: "", 
    overview:"Held in conjunction with the SAM series Skill Futures, Cloud Cryptid Friendship Society (CCFS) was an online performance by Feelers. Cloud Cryptids are fictional, mysterious creatures said to cluster around physical internet infrastructure. Audience members sat in on a meeting of the fictional Singapore Chapter of the CCFS, where cryptozoologists presented research they had undertaken to understand the local Cloud Cryptid population. ",
  },
		"silent-reading": {
    date: "Jun 2024",
    title: "Silent Reading",
    category: "Event",
    status: "Completed",
    overview: "Silent Reading was a series of weekly drop-in sessions hosted at Stranger Conversations for quiet companionship: with books, with each other, with the clouds, with The Cloud, with friends old and new. "
	},
  "szn-2024-touch-base": {
    date: "May 2024",
    title: "Season 2024: Touch Base",
    category: "Season",
    status: "Completed",
	image1: "/assets/szn2024_touch_base/szn2024_touch_base-2.webp",
	image2: "/assets/szn2024_touch_base/szn2024_touch_base-1.webp",
	image3: "/assets/szn2024_touch_base/szn2024_touch_base-3.webp", 
    overview: `Touch Base was Feelers’ 2024 Season, an annual series of interdisciplinary programmes that flow along circuits and fault lines between art and technology. With Touch Base, Feelers explored going back to the body, slowing down to examine the basics of how art and technology interact. This season consisted of: 

Random Access Memory: a movement workshop by Chew Shaw En which explored how an embodied encounter with technology might look and feel. 

Touch_Time (T_T): cosy gatherings where friends came together to play Cards Against Technology, mix kinetic cocktails, and reflect on fears around the future and technology. 

Let Me Show You What I Saw: a workshop which explored technologies of representation in art and culture, held at Art Outreach in collaboration with Open Offering 1 by About To Ask 

Liturgy of the Archipelago: a profile by Sharmini Aphrodite which featured Filipino ambient and internet artist Chia Amisola and Developh. In this editorial, Chia reflected on archipelagic memory and territory, the visibility of technology and labour, ritual and devotion, and folk histories. 

How To Go On: an intimate conversation with School of Altruism and The Slow Press, which explored how each group sustains and endures as an independent collective. ` 
  },
  performl: {
    date: "Mar 2024",
    title: "perfor.ml",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/performl/performl-1.webp",
	image2: "/assets/performl/performl-2.webp",
	image3: "", 
    overview: `Through perfor.ml, Feelers investigated the possibility of bringing machine learning into performance—on whose terms, and for what goals?

This iteration of the research process was a performance installation, bringing together human performers and kinetic sculptures on stage to explore systems of maintenance and upkeep in a subsea data centre. `  
  },
  pressplay: {
    date: "Jan 2024",
    title: "pressplay 2024: How To Build A Data Centre (Excerpt)",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/pressplay_howtobuild/pressplay_howtobuild-1.webp",
	image2: "",
	image3: "", 
    overview: `How To Build A Data Centre (Excerpt) was an installation as part of NLB’s 2024 PRESSPLAY Festival. 

In How To Build A Data Centre (Excerpt), bits of data, compressed and uniformly stored, were represented by two-dimensional image stacks of photographic print. Each successive frame of the kinetic installation carried the suggestion of a stop-motion film, yet no narrative was progressed. The flattening of information and the repetitive excess of time creates an infinite present prolonged into an indefinite future in conflict with everything living, changing, and developing in the world outside. Within this imagined data centre, scarcity becomes abundance.`
  },
  sonicality: {
    date: "Dec 2023",
    title: "Sonicality",
    category: "Research / Development",
    status: "Completed",
	image1: "/assets/sonicality/sonicality-1.webp",
    overview: `Sonicality was a collaboration with 55 Minutes design studio and Artwave studio to create an interactive microsite that used a 10-question quiz to reveal users’ unique sonic personalities, highlighting how sound influences their emotions and behavior. By engaging with tones, notes, and ambient sounds, users gained a deeper appreciation of the auditory aspects of their identity. 
`,
  },
  "soai-lite-2023": {
    date: "Oct 2023",
    title: "SoAI Lite 2023",
    category: "Education",
    status: "Completed",
    image1: "/assets/soailite_2023/soailite_2023-1.webp",
    image2: "/assets/soailite_2023/soailite_2023-2.webp",
    overview: `The School of Alternate Internets is an alt-educational program by Feelers for critical thinking, doing, and undoing around technology. After an in-person run of the school in July, SOAI Lite was a fully online, modular version of the program, featuring 11 drop-in sessions across 3 days (2, 3 and 7 December). These sessions included: comprehensive introductions to three contested emerging technologies: AI, the Metaverse, and Blockchain, lectures that bring quirky & non-obvious perspectives to technological experiences, and workshops to put these ideas into action, and expand ways of doing, feeling, and thinking about technology beyond its usual language and logic.
`,
  },
  totapo: {
    date: "Sep 2023",
    title: "Totapo",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/totapo/totapo-1.webp",
    image2: "/assets/totapo/totapo-2.webp",
    image3: "/assets/totapo/totapo-3.webp",
    overview: `For the first edition of the art x tech residency Totapo, artist Yifan Wang, student Bùi Nguyễn Bao Anh, and technologist Shivang Srivastava invited and hosted the blockchain in their homes. By interacting with their ‘Ether friend’ (an Ethereum node hosted on a Raspberry Pi), the residents aimed to inspire imaginative, caring, and affective ways of understanding the blockchain, as well as other emerging technologies.`,
  },
  "feeler-turns-3": {
    date: "Sep 2023",
    title: "Feelers Turns 3",
    category: "Event",
    status: "Completed",
    image1: "/assets/feelers_turns_3/feelers_turns_3-1.webp",
    image2: "/assets/feelers_turns_3/feelers_turns_3-2.webp",
    image3: "/assets/feelers_turns_3/feelers_turns_3-3.webp",
    overview: `A birthday party to celebrate Feelers' turning 3 years old, featuring kinetic cocktails by Ashley Hi, astrology chart readings by Ang Kia Yee, food by ants chua, and a DJ set by ila. `,
  },
  "the-internet-is-a-thing": {
    date: "Sep 2023",
    title: "The Internet Is a Thing",
    category: "Education",
    status: "Completed",
    image1: "/assets/the_internet_is_a_thing/the_internet_is_a_thing-1.webp",
    overview: `The Internet is a Thing is an art and tech workshop inviting participants to assemble a simple toy driven by the artist Chok Si Xuan and the artist collective Feelers. Connecting to the artwork HzHz by Chok Si Xuan, the workshop probes our understanding of various spaces we interact with, and how we perceive and distinguish them. While interacting in a virtual 3D space, The Internet is a Thing highlights how online worlds are dependent on offline infrastructure through an accessible and playful activity. Participants will be introduced to 3D printing through a demonstration by Feelers, and are encouraged to bring home their own 3D-printed toy!`,
  },
  "soai-2023": {
    date: "Jul 2023",
    title: "School of Alternate Internets 2023",
    category: "Education",
    status: "Completed",
    image1: "/assets/soai_2023/soai_2023-1.webp",
    image2: "/assets/soai_2023/soai_2023-2.webp",
		  overview: <p> 
				  <b>The School of Alternate Internets (SoAI)</b> is an educational program for critical thinking, doing, and undoing around technology. The inaugural edition of the program in July 2023 sought to bring critical perspectives to three contested technologies: Artificial Intelligence, Blockchain, and the Metaverse. Led by artists Ashley Hi, Johann Yamin and Ang Kia Yee, the program consisted of primers on these technologies and a series of workshops, including: <br /><br />

				  – Johann Yamin and Xafiér Yap's <b>Gaming The Metaverse</b>, which examined emergent online gaming communities, asking would it mean to queer the metaverse, to intercept with and game its logics. <br /> <br />
				  – Ang Kia Yee's <b>Cyber-Sacred Rituals</b>, where participants were invited to consider what it would look like to engage with the sacred and divine in tandem with technology and to see them as intimately connected rather than in opposition, more alike than not.<br /> <br />

				  – Ashley Hi's <b>Low-Tech Web</b>, which examined contemporary fixations on resource-intensive, algorithmically complex intelligences, challenging participants to consider naturally occurring intelligences and what it could look like if we took cues from permaculture practices in our technological practices.<br /> <br />


Having explored the constellation of technologies surrounding Web3, the final day of the School of Alternate Internets gave participants an opportunity to consolidate their learning through a day-long collaborative hackathon, where group came together to write, code, and illustrate gifs to create a Twine experience.<br /> <br />

		  </p>,
  },
  sketch2pigeon: {
    date: "May 2023",
    title: "sketch2pigeon",
    category: "Education",
    status: "Completed",
    image1: "/assets/sketch2pigeon/sketch2pigeon-1.webp",
    image2: "/assets/sketch2pigeon/sketch2pigeon-2.webp",
    image3: "/assets/sketch2pigeon/sketch2pigeon-3.webp",
    overview: `sketch2pigeon, run by Feelers' Tech Lead Ashley Hi, was a beginner’s machine learning workshop tracing the history of image-based ML techniques and their interfaces. 

In the 2.5 hour workshop, participants (most with minimal coding experience) learned how to access and make use of existing pre-trained models to create their own unique projects with minimal coding experience, touching on tools such as GANs, Midjourney, DALL-E, and ChatGPT. 
`,
  },
  "how-to-start": {
    date: "Apr 2023",
    title: "How to Start, How to Go On",
    category: "Print",
    status: "Completed",
    image1: "/assets/how_to_start/how_to_start-1.webp",
    overview: `How To Start, How To Go On is a collection of conversations, project lists, manifestos and essays that trace Feelers’ journey since its beginning in 2020. These speculative and silly works give a snapshot of Feelers’ vision as an art-tech label that is working towards a more sustainable, inhabitable and lively world. 
`,
  },
  "islands-residency": {
    date: "Mar 2023",
    title: "Islands Residency",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/islands_residency/islands_residency-1.webp",
		  overview: <p>From February-April 2023, Feelers was in residence at experimental art platform I_S_L_A_N_D_S with a programme series called Signal, not noise. Alongside free consultation drop-ins for Feelers' art, tech, and writing services, astrology readings, and an open studio, the team hosted mini-workshops, including: <br /><br />

				  – <i>Cybernetic Rituals For Right Now (CRFRN)</i>, a workshop where participants designed cybernetic rituals for themselves - for fun, joy, healing, and exploration.<br /><br />
				  – <i>Build Our Own Server (BOOS)</i> a workshop guiding participants through building a low power web server together to give islands their very own local network.<br /><br />
				  –<i>TLDR (Touch + Light, Determine Reaction)</i>, a workshop on how to build an interactive light circuit activated by touch.<br /><br />

		 </p>
,
  },
  sgabf2023: {
    date: "Apr 2023",
    title: "Singapore Art Book Fair 2023",
    category: "Exhibition / Performance",
    status: "Completed",
    overview: `Feelers teamed up with Singaporean theatre company Checkpoint Theatre to booth at Singapore Art Book fair for the very first time in 2023. 

Feelers presented three original publications: Eco-tech toolkit ‘Greener Screens’, ‘Writing Machine’, a collection of works co-written with other tools, phenomena and intelligences and Feelers' manifesto, ‘How To Start, How To Go On’. Feelers also released a very limited number of clay pigeons and keychain tokens that could be used to attend the workshops Kinetic Birds and sketch2pigeon.`,
  },
  "pecha-kucha": {
    date: "Mar 2023",
    title: "Pecha Kucha",
    category: "Event",
    status: "Completed",
    overview: `PechaKucha, in Japanese, actually means “chit-chat”. Feelers partnered with digital storytelling studio Tusitala to present a series of sharings from speakers using the PechaKucha 20 slides x 20 seconds format to present on a range of topics related to art, tech or both.

PechaKucha #1 (March 2023): Presentations covered the future of fashion design by Claudia Poh, the phenomena of the uncanny by Chok Sixuan, how to think about art and tech by Henrik Cheng, simplicity/complexity and 3D printing by Hui Yijian, and how AI can come together with Kathakali dance-drama by Ganesh Neelakanta.

PechaKucha #2 (June 2023): Presentations covered the use of eye tracking in user experience design by James Breeze, comparison between art and tech approaches by Julian Wong and speculative design and AR by Renee Wong. Simon Chesterman of AI Singapore spoke on whether we should trust AI, Kontinentalist Siti Aishah spoke on data storytelling and maps, and Syafiq Halid shared on intersection of Malay drums and electronic music.

PechaKucha #3 (August 2023): Audiovisual maker Lynette Quek shared about element of play within sound performance practices, Lecturer and education research scientist, Michael Tan made a case for dreaming, Architectural student, John Chew Geronimo Jr. spoke about how trees are represented in architecture, Syahiruddin, a full stack developer at River Valley Irregulars, shared his journey to becoming a self-resourced programmer, Actor and Cybersecurity & Digital Technology consultant, and Michael Chua shared his perspective on AI and film production. Finally, Totapo residents, Yifan Wang, Bui Nguyen Bao Anh, Srivang Srivastava, shared about their project to reimagine interactions with the blockchain. 
`,
  },
  "writing-machine": {
    date: "Mar 2023",
    title: "Writing Machine",
    category: "Print",
    status: "Completed",
    image1: "/assets/writing_machine/writing_machine-2.webp",
    image2: "/assets/writing_machine/writing_machine-1.webp",
    overview: `Writing Machine is an extension of a workshop Feelers conducted in early 2023, exploring the concept of authorship and co-writing with other tools, phenomena and intelligences. Turning to exercises that spanned the literary, computational and divinatory, Ang Kia Yee engaged with authorship as inherently shared — with code, chance, constraints, divination, their subconscious, and other human beings.
`,
  },
  "generative-dreaming": {
    date: "Nov 2022",
    title: "Generative Dreaming",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/generative_dreaming/generative_dreaming-1.webp",
    image2: "/assets/generative_dreaming/generative_dreaming-2.webp",
    overview: `Generative Dreaming reaches toward other worlds and futures through conversations between young artists who are learning how to make, how to persist, and what they desire.

Season 1 gathers practitioners who work across performance, installation, sculpture, and digital media to explore intersections between their practices.

In each episode, two artists chat about what, why and how they make what they make, as well as their visions for the future and the wider world. Their conversations reveal how we persist through care, community and creative strategy – not just as artists, but also as people.

Taking a structured but meandering approach, the artists of each episode roam across various themes — such as audience, body politics, and glitching. They reach toward one another to see what emerges, what is possible where they touch.
`,
  },
  "good-am-to-you": {
    date: "Nov 2022",
    title: "Good AM To You",
    category: "Event",
    status: "Completed",
    image1: "/assets/good_am/good_am-1.webp",
    image2: "/assets/good_am/good_am-2.webp",
    image3: "/assets/good_am/good_am-3.webp",
    overview: `Colloquially-known “Good Morning” WhatsApp images are easily identified by their colourful, saturated stock backgrounds featuring positive daily tidings in mismatched fonts. For the National Library Board's LOLA (RE)CONNECT Series, Feelers created a “Good Morning” graphics generator and hosted a sharing by graphic designers Qing (OuterEdit), Iffah Dahiyah (Fellow), and Izyanti Asa'ari (Fellow) on their favourite “Good Morning” graphics.

`,
  },
  "through-the-neighbours-walls": {
    date: "Nov 2022",
    title: `Through The Neighbour's Walls`,
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/through_the_neighbours/through_the_neighbours-1.webp",
    overview: `Feelers created an interactive rotary phone prop for Through the Neighbour's Walls, an experiential public installation which is an extension of the first episode of The Everyday Museum’s self-guided audio trail series, Speaking of which – An Organic Terminus.

Set in a living room from the past, a Rediffusion set broadcasted familiar programmes throughout the day, reliving its role as a companion to the worker and the homemaker, the young and the old. It alluded to a time when Rediffusion was woven into the fabric of our daily lives and served as a locus around which communities would gather.

When passers-by listened to the Rediffusion broadcasts, they were transported to a different time and space. Entering the living room took guests into the life of an imagined household where they would engage in intimate encounters. As they discovered traces left behind by family members, they were be invited to reflect upon and share their own fond memories of everyday pastimes.

This work was comissioned by The Everyday Museum in partnership with the National Archives of Singapore and with support from Rediffusion. Public interactions by Clarice Ng, set design and art direction by Junior Foong.

`,
  },
  "another-world-is-possible": {
    date: "Sep 2022",
    title: "Another World Is Possible",
    category: "Education",
    status: "Completed",
    image1: "/assets/another_world_is_possible/another_world_is_possible-1.webp",
    overview: `Another World is Possible was a panel discussion at the National Library about the role of design and technology in building a more ethical and equitable world.

Panellists Saad Chinoy (SpudnikLab), Claudia Poh (Werable) and Wendy Wong (55 Minutes), spoke on the pressing need for designs and technologies which value and empower the autonomy and needs of their users, the deepening digital divide, the ongoing shift from Web 2.0 to Web 3.0, as well as various considerations in achieving empathetic and user-centred design.
`,
  },
  "greener-screens": {
    date: "Sep 2022",
    title: "Greener Screens",
    category: "Education",
    status: "Completed",
    image1: "/assets/greener_screens/greener_screens-1.webp",
    image2: "/assets/greener_screens/greener_screens-2.webp",
    image3: "/assets/greener_screens/greener_screens-3.webp",
    overview: `In Greener Screens, Ashley Hi shared resources on greener tech habits and guided participants through creative exercises to build a sustainable tech toolkit that is customised to the needs of their own business or personal practice.

The workshop covered actionable design steps for greater energy efficiency, existing digital tools that minimise energy consumption, as well as Feelers’ own eco experiments.
`,
  },
  "talk-touch": {
    date: "Aug 2022",
    title: "Talk Touch",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/talk_touch/talk_touch-1.webp",
    image2: "/assets/talk_touch/talk_touch-2.webp",
    overview: `Feelers was matched with a team of five students for Singapore University of Technology and Design (SUTD)'s Capstone Design Programme. Over 7 months, Feelers mentored the Capstone team over a process of ideation, development and prototyping, where the students worked on the proposed idea of a haptic wearable.

This culminated in their capstone showcase, where they presented a prototype called TalkTouch. TalkTouch aims to enhance the experience of digital communication by providing real-time haptic feedback that bridges the gap of physical distance between loved ones, friends, and family. With a combination of a web application that communicates with a lightweight haptic backpack, wearers can experience the touch of a loved one even if they are oceans apart.
As the first-ever haptic device of its kind, TalkTouch has the potential to redefine remote communication and intimacy, with possible applications in the healthcare and arts industries.
`,
  },
  caterfeelers: {
    date: "Jun 2022",
    title: "Caterfeelers",
    category: "Education",
    status: "Completed",
    image1: "/assets/caterfeelers/caterfeelers-1.webp",
    image2: "/assets/caterfeelers/caterfeelers-2.webp",
    overview: `caterfeelers is a kinetic jewelry brand by Feelers which melds electronics and jewelry into distinctive wearables. Its first collection, launched in 2022, was 4 o'clock ___________, consisting of:

– brrr: a gentle and imaginative blessing for city romps. Made with omamori and mizuhiki knots, brrr offered well wishes for protection, togetherness and connection in the metropolis.

– click-click: a low-res third eye for another point of view. Its camera centrepiece hung upon a string of flowers, and came with three acrylic filters – grape, ultramarine and neon yellow.

– swish: a versatile charm necklace-meets-evolved fidget spinner. swish came in a half-and-half design of wire and charms which could unhook and hook along the necklace. The mini fan was activated by the push of a button.

– flutter: a light-up mask chain with small LED companions on either side. Buttons could be pressed to delight friends, send morse code messages, and brighten urban days.
`,
  },
  "kinetic-birds": {
    date: "May 2022",
    title: "Kinetic Birds",
    category: "Education",
    status: "Completed",
    image1: "/assets/kinetic_birds/kinetic_birds-1.webp",
    image2: "/assets/kinetic_birds/kinetic_birds-2.webp",
    overview: `In this hands-on workshop by Ashley Hi, participants could build and bring home their very own kinetic sculpture. Participants were given a guided introduction to Arduino + servo motors – how to connect and run them, load code to control the servo's speed/position, and work with external controls.
`,
  },
  "office-hands-edition": {
    date: "May 2022",
		  title: "Labs: Office: Hands Edition",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/labs_office_hands/labs_office_hands-1.webp",
		  overview: <p>Office: Hands Edition', a video work by Xafiér Yap, was inspired by the finger cramps and neck strains suffered by the artist at their desk job. The work was an experiment to understand the somatic relationship between the office employee and the laptop.<br /><br />

'Office: Hands Edition' depicts the human body conforming to objects of technology — one, with the laptop; and two, with the motion capture technology. Xafiér self-monitored their movements in the office. They found out that the sedentary body was stiff, tense and withheld. These movements were replicated in a motion capture studio. However— with any sort of technology— Xafiér’s body had to shift and exaggerate their movements in order to reproduce the same postures. The video is a result of this experiment. <br /><br />

				  <b>Office: Hands Edition</b> was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.<br /><br />
		  </p>,
  },
  "streetlamp-107101": {
    date: "Mar 2022",
    title: "Tracing Latencies:  Streetlamp No. 107101",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/streetlamp/streetlamp-1.webp",
    image2: "/assets/streetlamp/streetlamp-2.webp",
    overview: `Streetlamp No. 107101 was a responsive light installation which spoke to the heavy light pollution of our small city, which houses at least 107,100 streetlamps (as of 2017). By resisting our expectations of light, it was a meditation on relationships with visibility as inflected by personal and communal senses of safety, security, privacy and time. 

The work was created for Tracing Latencies, an exhibition by the Culture & Smart City Project, a multilateral and multidisciplinary collaborative initiative by EUNIC Singapore Cluster, supported by Goethe-Institut. The hybrid group exhibition was held from 3 March to 3 April 2022 at 136 GOETHE LAB, Singapore.
`,
  },
  "build-a-caifan": {
    date: "Nov 2021",
    title: "Build-A-Caifan",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/build_a_caifan/build_a_caifan-1.webp",
    image2: "/assets/build_a_caifan/build_a_caifan-2.webp",
    overview: `Build-A-Caifan was an imaginary online caifan stall which digitally replicated the experience of picking out dishes at a stall through clicking on food emojis. The dishes selected were reflected real-time as illustrations on a plate before being digitally "cooked" using machine learning to present a final, realistic-looking plate of piping-hot, ready-to-eat caifan.
`,
  },
  "painter-reviews-watercolour": {
    date: "Oct 2021",
    title: "Painter Reviews Watercolour Paints ",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/painter_reviews_watercolour/painter_reviews_watercolour-1.webp",
    overview: `We sat down with Mengju (@mengjuice) to learn about watercolour paints! Full video launches tomorrow at 8pm on YouTube and IG TV
`,
  },
  "peaceful-process": {
    date: "Oct 2021",
    title: "Peaceful Process / Making a Cup & Coaster",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/peaceful_process/peaceful_process-1.webp",
    overview: ``,
  },
  "labs-voices-in-a-room": {
    date: "Aug 2021",
    title: "Labs: voices in a room",
    category: "Print",
    status: "Completed",
    image1: "/assets/voices_in_a_room/voices_in_a_room-1.webp",
    image2: "/assets/voices_in_a_room/voices_in_a_room-2.webp",
    image3: "/assets/voices_in_a_room/voices_in_a_room-3.webp",
    overview: `Voices in a Room was a Feelers Labs performance project by ants chua, Ang Kia Yee, Chew Shaw En, Helen Cai, Rice Tan and txting teo. While the project initially started as an examination of language's possibilities in responding to and inhabiting times of crisis, current pressing griefs led them to dream collectively about the futures they wished to bring into being.

Voices in a Room was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.

In June 2024, Feelers revisited Voices in a Room with a series of recordings on Spotify, spoken aloud by Ang Kia Yee, Ashley Hi, ants chua, Alysha Chandra and Louise Marie Lee, with sound design and editing by Ada Adhiyatma.
`,
  },
  "labs-across-a-small-distance": {
    date: "Sep 2021",
    title: "Labs: Across a Small Distance",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/across_a_small_distance/across_a_small_distance-1.webp",
    image2: "/assets/across_a_small_distance/across_a_small_distance-2.webp",
    overview: `Across a Small Distance is a work-in-progress by Chew Shaw En & Jevon Chandra about the nature of landing, receiving and transmission. Through a sequence of movements and activities, the work explores the textures of communication in small settings: the things too near to touch, misunderstandings too slight to notice, tiny truths too inconvenient to say.

Across a Small Distance was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.
`,
  },
  "100-advertisements": {
    date: "Jul 2021",
    title: "Labs: 100 Advertisements - Now Online!",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/100_ads/100_ads-1.webp",
    image2: "/assets/100_ads/100_ads-2.webp",
    overview: `The first ever Labs project (and therefore first ever Feelers project) was 100 Advertisements - Now Online! by Eng Kai Er, a darkly humourous live virtual show about the pandemic, politics, and the artist's life as an international student in Germany.

𝟭𝟬𝟬 𝗔𝗱𝘃𝗲𝗿𝘁𝗶𝘀𝗲𝗺𝗲𝗻𝘁𝘀 - 𝗡𝗼𝘄 𝗢𝗻𝗹𝗶𝗻𝗲! was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.
`,
  },
  "souvenir": {
    date: "Feb 2021",
    title: "Souvenir",
    category: "Research / Development",
    status: "Completed",
		  overview: <p>Souvenir was an AR artwalk developed by Feelers and digital storytelling studio Tusitala, curated by Kirti Upadhyaya and featuring artists Hilary Yip, Nathanael Townsend and Ryan Benjamin Lee. The artists created site-specific AR artworks for the Jubilee Park playground within Fort Canning, which prompted the user to consider the natural and man-made elements of the playground environment.<br /><br />

				  <b>Souvenir</b> was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.<br /><br /></p>
  },
};

export default Projects;
